import { useState, useEffect } from 'react';
import { apiPrefix } from '../../utils/functions';
import spinnerDark from '../../icons/spinner-dark.64.gif';
import './initialise.css';

// ------------------------------------------------------------
//
// Wraps react App and executes startup code.
//
// ------------------------------------------------------------
export function AppInitialiser(args: { children: any }) {
  const [Completed, setCompleted] = useState<boolean>(false);

  // ------------------------------------------------------------
  //
  // Calls the /client_id endpoint to get a log ID cookie.
  //
  // ------------------------------------------------------------
  const ensure_client_id = async () => {
    try {
      // Request times out after 5 seconds.
      const apiResult = await fetch(apiPrefix() + '/v1/client_id', {
        method: 'GET',
        credentials: 'include',
        signal: AbortSignal.timeout(5000),
      });

      if (apiResult.status !== 200) {
        console.log('Failed to set client_id cookie.');
      }
    } catch (e) {
      console.log('Error setting client_id cookie:');
      console.log(e);
    }
    // Always set Completed to true allowing the app to be rendered, even if
    // initialisation code failed.
    setCompleted(true);
  };

  useEffect(() => {
    ensure_client_id();
  }, []);

  // Show loading screen while giving initialisation code a chance to run.
  if (!Completed) {
    return (
      <div className="loading-overlay">
        <div className="spinner-container">
          <span>loading...</span>
          <img src={spinnerDark} role="decoration" alt="" width="18" height="18" />
        </div>
      </div>
    );
  }

  // Display the main app.
  return <>{args.children}</>;
}
